export default __webpack_public_path__ + "static/media/alisha.18f6b135.jpg";